import { useEffect } from "react";

/**
 * Comportamento comum dos modais do módulo (o mesmo dos modais da Administração):
 * Esc fecha e o fundo não rola enquanto o modal está aberto.
 */
export function useModalChrome(isOpen: boolean, onClose: () => void, locked = false) {
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !locked) onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previous;
    };
  }, [isOpen, onClose, locked]);
}
